module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/convenios/detalles/convenios-detalles.component.scss
// module id = ./src/app/convenios/detalles/convenios-detalles.component.scss
// module chunks = main